import LocalImages from "assets/images/local-images";
import Body from "features/shared/styles/typography/Body.styled";
import { FC } from "react";

import ScanningWarningBannerStyled from "./styles/ScanningWarningBanner.styled";

interface ScanningWarningBannerProps {
  text: string;
  isError?: boolean;
}

const ScanningWarningBanner: FC<ScanningWarningBannerProps> = ({
  text,
  isError,
}) => {
  return (
    <ScanningWarningBannerStyled isError={isError}>
      <img
        alt="error icon"
        src={
          isError
            ? LocalImages.shared.images.icons.scannerError
            : LocalImages.shared.images.icons.scannerWarning
        }
      />
      <Body>{text}</Body>
    </ScanningWarningBannerStyled>
  );
};

export default ScanningWarningBanner;
